module.exports = "/images/malayali.svg?a80680d37585d53478b175d0d8831ea1";